<template>
  <div class="legend-bar">
    <div class="filter-parent">
      <div class="legend">
        <div
          class="legend-selection"
          style="background-color: rgb(252, 197, 192);"
        ></div>
        <div
          class="legend-selection"
          style="background-color: rgb(250, 159, 181);"
        ></div>
        <div
          class="legend-selection"
          style="background-color: rgb(247, 104, 161);"
        ></div>
        <div
          class="legend-selection"
          style="background-color: rgb(197, 27, 138);"
        ></div>
        <div
          class="legend-selection"
          style="background-color: rgb(122, 1, 119);"
        ></div>
      </div>
      <div class="flex-row" v-if="enableFilter">
        <div class="mask left" :style="{ width: `${left}%` }"></div>
        <div class="mask right" :style="{ width: `${100 - right}%` }"></div>
      </div>
      <div class="thumb-wrapper mar-right-5" v-if="enableFilter">
        <div class="thumb left" :style="{ left: `${left}%` }">
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </div>
      <div class="thumb-wrapper mar-left-5" v-if="enableFilter">
        <div class="thumb right" :style="{ right: `${100 - right}%` }">
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </div>
      <input
        v-if="enableFilter"
        type="range"
        tabindex="0"
        value="0"
        max="100"
        min="0"
        step="1"
        @input="handleLeft"
        @change="handleChange"
        ref="leftSlider"
      />
      <input
        v-if="enableFilter"
        type="range"
        tabindex="0"
        value="100"
        max="100"
        min="0"
        step="1"
        @input="handleRight"
        @change="handleChange"
        ref="rightSlider"
      />
    </div>
    <div class="legend text">
      <p v-for="(value, index) in legend" :key="index">
        {{ formatNumber(value) }}
      </p>
    </div>
  </div>
</template>

<script>
import { format } from "@/lib/numberFormatter";

export default {
  props: {
    legend: Array,
    enableFilter: Boolean,
  },
  data() {
    return {
      left: 0,
      right: 100,
    };
  },
  watch: {},
  methods: {
    handleLeft(e) {
      this.$refs.leftSlider.value = Math.min(
        parseInt(e.target.value),
        parseInt(this.$refs.rightSlider.value) - 24
      );

      this.left = this.$refs.leftSlider.value;
    },
    handleRight(e) {
      this.$refs.rightSlider.value = Math.max(
        parseInt(e.target.value),
        parseInt(this.$refs.leftSlider.value) + 24
      );
      this.right = this.$refs.rightSlider.value;
    },
    handleChange(e) {
      const data = {
        min: parseInt(this.left),
        max: parseInt(this.right),
      };
      this.$emit("applyFilter", data);
    },
    formatNumber(num) {
      let value = parseFloat(num || 0);
      value = isNaN(value) ? 0 : value;
      value = format(value.toFixed(0), 2);
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-bar {
  display: flex;
  flex-direction: column;
  width: 250px;

  .filter-parent {
    position: relative;
    width: 220px;
    margin: 0 auto;

    .mask {
      height: 10px;
      margin: 5px 0;
      background: var(--popup-background-color);
      position: absolute;
      top: 0;

      &.left {
        left: 0;
      }

      &.right {
        right: 0;
      }
    }

    input[type="range"] {
      top: 0;
      position: absolute;
      pointer-events: none;
      -webkit-appearance: none;
      z-index: 2;
      height: 10px;
      width: 100%;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
      filter: alpha(opacity=0);
      -moz-opacity: 0;
      -khtml-opacity: 0;
      opacity: 0;
    }

    input[type="range"]::-ms-track {
      -webkit-appearance: none;
      pointer-events: none;
      background: transparent;
      color: transparent;
    }

    input[type="range"]::-moz-range-track {
      -moz-appearance: none;
      pointer-events: none;
      background: transparent;
      color: transparent;
    }

    input[type="range"]:focus::-webkit-slider-runnable-track {
      pointer-events: none;
      background: transparent;
      border: transparent;
    }

    input[type="range"]:focus {
      outline: none;
    }

    input[type="range"]::-ms-thumb {
      pointer-events: all;
      width: 15px;
      height: 20px;
      border-radius: 0px;
      border: 0 none;
      background: red;
      &:hover {
        cursor: ew-resize;
      }
    }

    input[type="range"]::-moz-range-thumb {
      pointer-events: all;
      width: 15px;
      height: 20px;
      border-radius: 0px;
      border: 0 none;
      background: red;
      &:hover {
        cursor: ew-resize;
      }
    }

    input[type="range"]::-webkit-slider-thumb {
      pointer-events: all;
      width: 15px;
      height: 20px;
      border-radius: 0px;
      border: 0 none;
      background: red;
      -webkit-appearance: none;
      &:hover {
        cursor: ew-resize;
      }
    }

    input[type="range"]::-ms-fill-lower {
      background: transparent;
      border: 0 none;
    }

    input[type="range"]::-ms-fill-upper {
      background: transparent;
      border: 0 none;
    }

    input[type="range"]::-ms-tooltip {
      display: none;
    }

    .thumb {
      position: absolute;
      width: 10px;
      height: 20px;
      background: var(--font-color);
      border-radius: 1px;
      top: 0;
      z-index: 3;
      pointer-events: none;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      .line {
        width: 1px;
        height: 12px;
        background: var(--color-secondary);
        opacity: 0.5;
      }

      &.left {
        left: 0%;
      }

      &.right {
        right: 0%;
      }
    }
  }
  .legend {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    margin: 5px 0px;

    &.text {
      margin: 0 15px 10px 15px;
    }
    div {
      height: 10px;
    }
    p {
      padding: 3px 0;
      margin: 0;
      font-size: 0.8em;
      color: var(--font-color);
    }
  }
}
</style>
